import { PS_ERROR_MESSAGE_MAP } from '../constants/psErrorMessageMap';

const createPSErrorFallbackMap = (): Record<string, string> => {
    const resultMap: Record<string, string> = {};
    const duplicateKeys = new Set<string>();
    Object.entries(PS_ERROR_MESSAGE_MAP).forEach(([key, value]) => {
        const psMessage = key.split('_')[1] || key;
        if (resultMap[psMessage]) {
            duplicateKeys.add(psMessage);
        } else {
            resultMap[psMessage] = value;
        }
    });
    duplicateKeys.forEach((key) => delete resultMap[key]);

    return resultMap;
};

const psErrorFallbackMap = createPSErrorFallbackMap();

export const getPSErrorFallbackMessage = (lookupKey: string): string => {
    const psMessage = lookupKey.split('_')[1];
    return psErrorFallbackMap[psMessage] || '';
};

export const parseMessageWithTitle = (error: string): string[] => {
    if (error.includes(':')) {
        const [title, message] = error.split(':');
        return [title, message];
    }
    return ['', error];
};
